require('./preLeaveModalComponent.override.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @utils
const { FormattedText, formatText } = require('core/i18n').i18n;

// @component
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

class BrokerCustomWalletPreLeaveEditionModal extends React.Component {
    constructor(props) {
        super(props);

        this.buildModalTitle = this.buildModalTitle.bind(this);
        this.buildModalText = this.buildModalText.bind(this);
        this.handleOnConfirmLeave = this.handleOnConfirmLeave.bind(this);
        this.skipLeaveEditionModal = this.skipLeaveEditionModal.bind(this);
    }

    buildModalText() {
        const { walletName } = this.props;

        return (
            <div className="custom-wallet-configuration__leave-edition-modal-text">
                <div>
                    <FormattedText value="brokerCustomWallet-leaveEditionWalletText"
                        injectedStrings={[walletName]}
                    />
                </div>
                <div>
                    <FormattedText value="brokerCustomWallet-leaveEditionWalletText2" />
                </div>
                <div className="custom-wallet-configuration__leave-edition-modal-info">
                    <FormattedText value="brokerCustomWallet-leaveEditionWalletInfo" />
                </div>
            </div>
        );
    }

    buildModalTitle() {
        return (
            <h3 className="custom-wallet-configuration__leave-edition-modal-title">
                <FormattedText value="brokerCustomWallet-leaveEditionWalletTitle" />
            </h3>
        );
    }

    handleOnConfirmLeave() {
        this.props.onConfirmLeaveEditionToOtherPage();
    }

    skipLeaveEditionModal() {
        const { immBrokerCustomWalletPortfolios } = this.props;

        return immBrokerCustomWalletPortfolios.get('skipLeaveEditionModal');
    }

    render() {
        const modalTitle = this.buildModalTitle();
        const modalText = this.buildModalText();
        const acceptText = formatText('brokerCustomWallet-buttonConfirmLeaveEditionWallet');
        const cancelText = formatText('brokerCustomWallet-buttonCancelLeaveEditionWallet');
        const leftButtonConfig = ({
            text: cancelText,
            redirect: false  
        });

        const rightButtonConfig = ({
            text: acceptText,
            redirect: true  
        });

        return (
            <PreLeaveModalComponent
                confirmationMessage={modalText}
                confirmationTitle={modalTitle}
                leftButtonConfig={leftButtonConfig}
                rightButtonConfig={rightButtonConfig}
                isReady={this.skipLeaveEditionModal}
                onConfirmLeave={this.handleOnConfirmLeave}
                className="cw-modal"
                cwModal={true}
            />
        );
    }

}

BrokerCustomWalletPreLeaveEditionModal.propTypes = {
    walletName: PropTypes.string.isRequired,
    immBrokerCustomWalletPortfolios: PropTypes.any.isRequired,
    onConfirmLeaveEditionToOtherPage: PropTypes.func.isRequired
};

module.exports = BrokerCustomWalletPreLeaveEditionModal;
